import React from "react";
export default function OptimizeYourSupplyChainWithExpertAdvisory() {
  return <section className="bg-background py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center animate-fade-in-up">
          <h2 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            Optimize Your Supply Chain with Expert Advisory
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
            Aran Group brings deep expertise in supply chain management, vendor
            selection, and contract management. Our Turnkey Vendor/Procurement
            Advisory service helps companies streamline their procurement
            processes, reduce costs, and build stronger vendor relationships—all
            while maintaining quality and compliance standards.
          </p>
        </div>
      </div>
    </section>;
}